import { createSlice } from "@reduxjs/toolkit";
import { MembershipSubmitApi, GetCompanyListApi, ExternalLoginApi } from "../api/MembershipApi";

const initialState = {
  membershipData: {},
  companyList: {},
  externalLoginData: null,
  successMessage: null,
  loading: false,
  error: null,
};

const MembershipSlice = createSlice({
  name: "MembershipSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(MembershipSubmitApi.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(MembershipSubmitApi.fulfilled, (state, action) => {
        state.loading = false;
        state.membershipData = action.payload.data;
        state.successMessage = action.payload.message;
      })
      .addCase(MembershipSubmitApi.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(GetCompanyListApi.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(GetCompanyListApi.fulfilled, (state, action) => {
        state.loading = false;
        state.companyList = action.payload.data;
        state.successMessage = action.payload.message;
      })
      .addCase(GetCompanyListApi.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(ExternalLoginApi.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(ExternalLoginApi.fulfilled, (state, action) => {
        state.loading = false;
        state.externalLoginData = action.payload;
        state.successMessage = action.payload.message;
      })
      .addCase(ExternalLoginApi.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error.message;
      });
  },
});

export default MembershipSlice.reducer;
